import React from 'react';
import PropTypes from 'prop-types';

function PdfIcon({ width, height, color }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/1999/xlink"
    >
      <desc>Created with sketchtool.</desc>
      <g
        id="🌈-Style-"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Icons"
          transform="translate(-902.000000, -120.000000)"
          fill={color}
        >
          <g id="Colors-Copy" transform="translate(22.000000, 20.000000)">
            <path
              d="M899.885918,105.412383 L894.478695,100.117891 C894.401715,100.042578 894.295509,100 894.184578,100 L886.125498,100 C885.223582,100 884.489804,100.691172 884.489804,101.540703 L884.489804,106.923086 L881.223765,106.923086 C880.548976,106.923086 880,107.440234 880,108.075937 L880,113.847188 C880,114.482852 880.548976,115 881.223765,115 L884.489804,115 L884.489804,118.461992 C884.489804,119.310039 885.223582,120 886.125498,120 L898.364306,120 C899.266222,120 900,119.31043 900,118.462852 L900,105.679102 C900,105.579648 899.959085,105.484062 899.885918,105.412383 Z M894.285726,101.03832 L898.724583,105.384609 L894.285726,105.384609 L894.285726,101.03832 Z M893.469372,100.769219 L893.469372,105.769219 C893.469372,105.981641 893.652143,106.153828 893.877528,106.153828 L899.183646,106.153828 L899.183646,118.462852 C899.183646,118.886289 898.816073,119.230781 898.364265,119.230781 L886.125498,119.230781 C885.67369,119.230781 885.306117,118.885938 885.306117,118.462031 L885.306117,115 L892.245648,115 C892.920437,115 893.469413,114.482852 893.469413,113.847188 L893.469413,108.075938 C893.469413,107.440234 892.920437,106.923086 892.245648,106.923086 L885.306117,106.923086 L885.306117,101.540703 C885.306117,101.115273 885.67369,100.769219 886.125498,100.769219 L893.469372,100.769219 Z M883.242236,109.0625 C883.684473,109.0625 884.000176,109.138935 884.189355,109.291807 C884.378534,109.44468 884.473122,109.700167 884.473122,110.058277 C884.473122,110.463684 884.346595,110.779137 884.093538,111.004645 C883.84048,111.230153 883.486286,111.342905 883.030946,111.342905 L882.716469,111.342905 L882.716469,112.8125 L881.974497,112.8125 L881.974497,109.0625 L883.242236,109.0625 Z M886.62533,109.0625 C887.188772,109.0625 887.620356,109.216637 887.920094,109.524916 C888.219832,109.833194 888.369699,110.277869 888.369699,110.858953 C888.369699,111.477199 888.210824,111.957346 887.893069,112.299409 C887.575313,112.641471 887.130627,112.8125 886.558995,112.8125 L885.060311,112.8125 L885.060311,109.0625 L886.62533,109.0625 Z M891.337584,109.0625 L891.337584,109.576858 L889.806961,109.576858 L889.806961,110.717061 L891.064873,110.717061 L891.064873,111.233953 L889.806961,111.233953 L889.806961,112.8125 L889.050249,112.8125 L889.050249,109.0625 L891.337584,109.0625 Z M886.273999,109.576858 L885.817024,109.576858 L885.817024,112.280405 L886.382101,112.280405 C886.780114,112.280405 887.076981,112.166809 887.272712,111.939611 C887.468443,111.712414 887.566307,111.367401 887.566307,110.904561 C887.566307,110.546451 887.487688,110.248312 887.330448,110.010135 C887.222346,109.846283 887.092134,109.733108 886.939808,109.670608 C886.787482,109.608108 886.565548,109.576858 886.273999,109.576858 Z M883.011292,109.576858 L882.716469,109.576858 L882.716469,110.828547 L882.86388,110.828547 C883.12267,110.828547 883.326997,110.76647 883.476866,110.642314 C883.626735,110.518158 883.701669,110.349663 883.701669,110.136824 C883.701669,109.763512 883.471545,109.576858 883.011292,109.576858 Z"
              id="File-/-PDF"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

PdfIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string
};

PdfIcon.defaultProps = {
  width: '20px',
  height: '20px',
  color: 'white'
};

export default PdfIcon;
